import { render } from "./WaterOff.vue?vue&type=template&id=636e6358"
import script from "./WaterOff.vue?vue&type=script&lang=js"
export * from "./WaterOff.vue?vue&type=script&lang=js"

import exportComponent from "../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"@apostrophecms/vue-material-design-icons/WaterOff.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "636e6358"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('636e6358', __exports__)) {
    api.reload('636e6358', __exports__)
  }
  
  module.hot.accept("./WaterOff.vue?vue&type=template&id=636e6358", () => {
    api.rerender('636e6358', render)
  })

}


export default __exports__